import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import QuemSomos from './components/QuemSomos';
import Contato from './components/Contato';
import Footer from './components/Footer';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import './App.css';

function LandingPageContent() {
  return (
    <>
      <main>
        <section 
          id="hero" 
          className="hero-section" 
          /* style={{
            backgroundImage: "url('/images/background-hero.jpg')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            position: 'relative'
          }} */
        >
          <Hero />
        </section>

        <section id="quem-somos" className="quem-somos-section">
          <QuemSomos />
        </section>

        <section id="contato" className="contato-section">
          <Contato />
        </section>
      </main>
      <Footer />
    </>
  );
}

function App() {
  const sections = [
    { id: 'hero', name: 'Início', path: '/' },
    { id: 'quem-somos', name: 'Quem Somos', path: '/#quem-somos' },
    { id: 'contato', name: 'Contato', path: '/#contato' },
  ];

  return (
    <div className="App">
      <Header sections={sections} />

      <Routes>
        <Route path="/" element={<LandingPageContent />} />

        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/termos-de-uso" element={<TermosUso />} />
      </Routes>
    </div>
  );
}
export default App;